import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Typography,
  Chip,
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
  MenuItem,
  Button,
  TextField,
} from '@mui/material';
import {useState} from 'react'
import { SaveAlt as SaveAltIcon, Add as AddIcon } from '@mui/icons-material';
import {Row,Col} from 'react-bootstrap';
import './AddAsset2.css';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function AddAsset2({handlePrevious,handleNext,order}) {

  const [fuelType, setFuelType] = React.useState('Gas');
  const theme = useTheme();
  var [windowWidth,setWindowWidth] = useState(window.outerWidth);

  // window.onresize(()=>{
  //   setWindowWidth(window.outerWidth)
  // })

  const [definedFacilities1, setDefinedFacilities1] = React.useState([
    'Stereo',
    'Bluetooth',
    'Hydraulic Swim platform ',
  ]);
  const [definedFacilities2, setDefinedFacilities2] = React.useState([
    'Inflatable Floats',
    'Ice',
    'Bottled Waters ',
    'Jetskis ',
    'Paddleboards',
    'Dingy',
    'Wakeboard',
    'Seabobs',
    'Slide',
    'Hydrofoil',
    'Sailboat',
    'Dive Equipment',
    'Gym and workout equipment',
    'Fishing Gear',
    'Hot Tub',
    'Sauna',
    'Inflatable Trampoline',
  ]);
  const [facilities1, setfacilities1] = React.useState([]);
  const [facilities2, setfacilities2] = React.useState([]);
  const [newFacility1, setNewFacility1] = React.useState([]);
  const [newFacility2, setNewFacility2] = React.useState([]);

  const handleChange1 = (event) => {
    const {
      target: { value },
    } = event;
    setfacilities1(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleChange2 = (event) => {
    const {
      target: { value },
    } = event;
    setfacilities2(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleNewFacility1 = (e) => {
    setNewFacility1(e.target.value);
  };

  const addNewFacility1 = () => {
    if (newFacility1)
      setDefinedFacilities1((prev) => prev.concat(newFacility1));
  };

  const handleNewFacility2 = (e) => {
    setNewFacility2(e.target.value);
  };

  const addNewFacility2 = () => {
    if (newFacility2)
      setDefinedFacilities2((prev) => prev.concat(newFacility2));
  };

  const handleChange = (e) => {
    setFuelType(e.target.value);
  };

  return (
    <div className='addAsset1_Main'>
      <Row>
        <Col sm={6}>
        <input className='Passengers_Limit addAsset2_Input' placeholder='Passengers Limit' />
        </Col>
        <Col sm={6}>
        <input className='Number_Bathrooms addAsset2_Input' placeholder='Number of Bathrooms' />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
        <select
          value={fuelType}
         className='type addAsset1_Input'
          onChange={handleChange}>
          <option value='Gas'>Gas</option>
          <option value='Diesel'>Diesel</option>
        </select>
        </Col>
        <Col>
        </Col>
      </Row>

      <Row>
      <p className='sleepingTxt'>Sleeping Accommodation</p>
      </Row>

      <Row>
        <Col sm={6}>
        <input className='Queen_Beds addAsset1_Input' placeholder='Queen/King Beds' />
        </Col>
        <Col sm={6}>
        <input className='Twin_Beds addAsset1_Input' placeholder='Twin Beds' />
        </Col>
      </Row>


      <Row>
        <Col sm={6}>
        <input className='Number_Cabins addAsset1_Input' placeholder='Number of Cabins' />
        </Col>
        <Col>
        </Col>
      </Row>

      <br />

      <Row>
        <Col md={5} sm={5}>
        <select
        placeholder='Electronics and Technical'
            value={facilities1}
         className='type addAsset1_Input'
            onChange={handleChange1}>
            {definedFacilities1.map((name) => (
              <option
                key={name}
                value={name}
                >
                {name}
              </option>
            ))}
        </select>
        </Col>
        <Col md={5} sm={5}>
        <input className='Number_Cabins addAsset1_Input' placeholder='' 
          value={newFacility1}
          onChange={handleNewFacility1}
        />
        </Col>
        <Col md={2} sm={2}  className='ast2AdBtn'>
        <button
        className='addBtnAsset2'
          onClick={addNewFacility1}>        
        
        Add
        </button>

        </Col>

      </Row>

      <Row>
        <Col md={5} sm={5}>
        <select
        placeholder='Electronics and Technical'
            value={facilities2}
         className='type addAsset1_Input'
            onChange={handleChange2}>
            {definedFacilities2.map((name) => (
              <option
                key={name}
                value={name}
                >
                {name}
              </option>
            ))}
        </select>
        </Col>
        <Col md={5} sm={5}>
        <input className='Number_Cabins addAsset1_Input' placeholder='' 
          value={newFacility2}
          onChange={handleNewFacility2}
        />
        </Col>
        <Col md={2} sm={2}  className='ast2AdBtn'>
        <button
        className='addBtnAsset2'
          onClick={addNewFacility2}>        
        
        Add
        </button>
        </Col>

      </Row>

      <div className='chngBtnDiv' >
      <button
        className='prevBtn'
        onClick={handlePrevious}
        disabled={order === 0}
        >
        Prev
      </button>
      <button
        className='nextBtn'
        disabled={order === 3}
        onClick={handleNext}
        >
        Next
      </button>
      </div>
      <br />
    </div>
  );
}
